module.exports = __webpack_public_path__ + "img/grid-1.348f6cca.jpg";